/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.223.0-v202611042211-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqAuditApiClass {
 
   constructor() {}

  /**
   * @summary Version a Locked item and create a new Version History.
  */
  public createVersionHistory(
    body: models.VersionInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/audit/version`;
    const urlTemplate = `${baseUrl}/audit/version`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.VersionHistoryOutputV1>;
  }

  /**
   * @summary Get a collection of Audit Trail entries
   * @param {string} [startTime] - The start time for the query, formatted as an ISO 8601 timestamp (YYYY-MM-DDThh:mm:ss.sssssssss±hh:mm)
   * @param {string} [endTime] - The end time for the query, formatted as an ISO 8601 timestamp (YYYY-MM-DDThh:mm:ss.sssssssss±hh:mm)
   * @param {Array<string>} [userID] - User ID(s) to filter on
   * @param {Array<string>} [itemID] - Item ID(s) to filter on
   * @param {Array<string>} [itemType] - Item type(s) to filter on
   * @param {Array<string>} [changeType] - Change type(s) to filter on (Create, Update, Delete)
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=100] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @param {boolean} [sortAsc=true] - When true sorts by oldest entries first, when false sorts by newest entries first
   * @param {boolean} [hideSystemEntries=true] - When true, entries created by system managed users will be hidden from the results
   * @param {string} [searchField=ITEM_NAME]
   * @param {string} [textSearch]
   * @param {Array<string>} [workbookIDs]
   * @param {boolean} [includeUnchangedProperties=false] - When true, UPDATE and DELETE entries will include all item properties at that point in time, not just the properties that changed. Properties are accumulated from all prior entries in chronological order, providing the complete state of the properties at that time.
  */
  public getAuditEntries(
    {
      startTime,
      endTime,
      userID,
      itemID,
      itemType,
      changeType,
      offset,
      limit,
      sortAsc,
      hideSystemEntries,
      searchField,
      textSearch,
      workbookIDs,
      includeUnchangedProperties
    } : {
      startTime?: string,
      endTime?: string,
      userID?: Array<string>,
      itemID?: Array<string>,
      itemType?: Array<string>,
      changeType?: GetAuditEntriesChangeTypeEnum[],
      offset?: number,
      limit?: number,
      sortAsc?: boolean,
      hideSystemEntries?: boolean,
      searchField?: GetAuditEntriesSearchFieldEnum,
      textSearch?: string,
      workbookIDs?: Array<string>,
      includeUnchangedProperties?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/audit`;
    const urlTemplate = `${baseUrl}/audit`;

    const queryParams = {
      ['startTime']: startTime,      ['endTime']: endTime,      ['userID']: userID,      ['itemID']: itemID,      ['itemType']: itemType,      ['changeType']: changeType,      ['offset']: offset,      ['limit']: limit,      ['sortAsc']: sortAsc,      ['hideSystemEntries']: hideSystemEntries,      ['searchField']: searchField,      ['textSearch']: textSearch,      ['workbookIDs']: workbookIDs,      ['includeUnchangedProperties']: includeUnchangedProperties
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.AuditOutputListV1>;
  }

  /**
   * @summary Get all the Version Histories this user has access to, or get all the Version Histories pertaining to an item that was created by cloning a versioned item.
   * @param {boolean} [isArchived=false]
   * @param {string} [duplicateItemId]
   * @param {Array<string>} [versionedItemType] - Optional filter on the type of items versioned by the returned Version Histories. Repeat this query parameter to include multiple types.
   * @param {string} [itemId] - If provided, return only Version Histories that contain at least one version of this item.
   * @param {Array<string>} [itemIds] - Return Version Histories containing at least one version of any of these items. Repeat this query parameter to include multiple items. For a history without an access-control parent, READ access to a requested item also makes that item&#x27;s matching history visible; access to one requested item does not expose histories belonging only to other requested items.
  */
  public getVersionHistories(
    {
      isArchived,
      duplicateItemId,
      versionedItemType,
      itemId,
      itemIds
    } : {
      isArchived?: boolean,
      duplicateItemId?: string,
      versionedItemType?: Array<string>,
      itemId?: string,
      itemIds?: Array<string>
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/audit/version-histories`;
    const urlTemplate = `${baseUrl}/audit/version-histories`;

    const queryParams = {
      ['isArchived']: isArchived,      ['duplicateItemId']: duplicateItemId,      ['versionedItemType']: versionedItemType,      ['itemId']: itemId,      ['itemIds']: itemIds
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.VersionHistoryOutputListV1>;
  }

  /**
   * @summary Get a specific Version History that this user has access to
   * @param {string} versionHistoryId
  */
  public getVersionHistory(
    {
      versionHistoryId
    } : {
      versionHistoryId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (versionHistoryId === null || versionHistoryId === undefined) {
      throw new Error("'versionHistoryId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/audit/version-history/${encodeURIComponent(String(versionHistoryId))}`
      .replace('{versionHistoryId}', encodeURIComponent(String(versionHistoryId)));
    const urlTemplate = `${baseUrl}/audit/version-history/{versionHistoryId}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.VersionHistoryOutputV1>;
  }

  /**
   * @summary Manually set or clear the production version of a Version History.
   * @param {string} versionHistoryId - ID of the Version History whose production version is being changed.
  */
  public setProductionVersion(
    body: models.SetProductionVersionInputV1,
    {
      versionHistoryId
    } : {
      versionHistoryId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (versionHistoryId === null || versionHistoryId === undefined) {
      throw new Error("'versionHistoryId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/audit/version-history/${encodeURIComponent(String(versionHistoryId))}/production-version`
      .replace('{versionHistoryId}', encodeURIComponent(String(versionHistoryId)));
    const urlTemplate = `${baseUrl}/audit/version-history/{versionHistoryId}/production-version`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ProductionVersionOutputV1>;
  }

  /**
   * @summary Version a Locked item and add it to an existing Version History.
   * @param {string} versionHistoryId - ID of the Version History to add this Version to.
  */
  public updateVersionHistory(
    body: models.VersionInputV1,
    {
      versionHistoryId
    } : {
      versionHistoryId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (versionHistoryId === null || versionHistoryId === undefined) {
      throw new Error("'versionHistoryId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/audit/version/${encodeURIComponent(String(versionHistoryId))}`
      .replace('{versionHistoryId}', encodeURIComponent(String(versionHistoryId)));
    const urlTemplate = `${baseUrl}/audit/version/{versionHistoryId}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.VersionHistoryOutputV1>;
  }

}

export const GetAuditEntriesChangeTypeEnum = {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE'
} as const;

export type GetAuditEntriesChangeTypeEnum = typeof GetAuditEntriesChangeTypeEnum[keyof typeof GetAuditEntriesChangeTypeEnum];
export const GetAuditEntriesSearchFieldEnum = {
    ALL: 'ALL',
    ITEMID: 'ITEM_ID',
    ITEMNAME: 'ITEM_NAME',
    ITEMTYPE: 'ITEM_TYPE',
    CHANGEDBY: 'CHANGED_BY'
} as const;

export type GetAuditEntriesSearchFieldEnum = typeof GetAuditEntriesSearchFieldEnum[keyof typeof GetAuditEntriesSearchFieldEnum];

export const sqAuditApi = new sqAuditApiClass();

export type sqAuditApiEndpoints = {
  'createVersionHistory': {
    method: 'post';
    path: '/audit/version';
    response: models.VersionHistoryOutputV1;
  };
  'getAuditEntries': {
    method: 'get';
    path: '/audit';
    response: models.AuditOutputListV1;
  };
  'getVersionHistories': {
    method: 'get';
    path: '/audit/version-histories';
    response: models.VersionHistoryOutputListV1;
  };
  'getVersionHistory': {
    method: 'get';
    path: '/audit/version-history/${encodeURIComponent(String(versionHistoryId))}';
    response: models.VersionHistoryOutputV1;
  };
  'setProductionVersion': {
    method: 'post';
    path: '/audit/version-history/${encodeURIComponent(String(versionHistoryId))}/production-version';
    response: models.ProductionVersionOutputV1;
  };
  'updateVersionHistory': {
    method: 'post';
    path: '/audit/version/${encodeURIComponent(String(versionHistoryId))}';
    response: models.VersionHistoryOutputV1;
  };
};

type ApiCreateVersionHistoryResponse = models.VersionHistoryOutputV1;
type ApicreateVersionHistoryMutationParams = Parameters<typeof sqAuditApi.createVersionHistory> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAuditApi.createVersionHistory>;
type ApicreateVersionHistoryMutationVariables = models.VersionInputV1;

export function useApiCreateVersionHistoryMutation(
  options?: Omit<UseMutationOptions<ApiCreateVersionHistoryResponse, AxiosError<SeeqErrorData>,
    ApicreateVersionHistoryMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateVersionHistoryResponse, AxiosError<SeeqErrorData>,
  ApicreateVersionHistoryMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicreateVersionHistoryMutationVariables) =>
      sqAuditApi.createVersionHistory(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetAuditEntriesResponse = models.AuditOutputListV1;
export function GetAuditEntriesQueryKey(
  params: Parameters<typeof sqAuditApi.getAuditEntries>[0],
) {
  return ['sqAuditApi', 'getAuditEntries', params] as const;
}

export function useApiGetAuditEntriesQuery(
  params: Parameters<typeof sqAuditApi.getAuditEntries>[0],
  options?: Omit<UseQueryOptions<ApiGetAuditEntriesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetAuditEntriesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetAuditEntriesQueryKey(params),
    queryFn: () =>
      sqAuditApi.getAuditEntries(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetVersionHistoriesResponse = models.VersionHistoryOutputListV1;
export function GetVersionHistoriesQueryKey(
  params: Parameters<typeof sqAuditApi.getVersionHistories>[0],
) {
  return ['sqAuditApi', 'getVersionHistories', params] as const;
}

export function useApiGetVersionHistoriesQuery(
  params: Parameters<typeof sqAuditApi.getVersionHistories>[0],
  options?: Omit<UseQueryOptions<ApiGetVersionHistoriesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetVersionHistoriesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetVersionHistoriesQueryKey(params),
    queryFn: () =>
      sqAuditApi.getVersionHistories(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetVersionHistoryResponse = models.VersionHistoryOutputV1;
export function GetVersionHistoryQueryKey(
  params: Parameters<typeof sqAuditApi.getVersionHistory>[0],
) {
  return ['sqAuditApi', 'getVersionHistory', params] as const;
}

export function useApiGetVersionHistoryQuery(
  params: Parameters<typeof sqAuditApi.getVersionHistory>[0],
  options?: Omit<UseQueryOptions<ApiGetVersionHistoryResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetVersionHistoryResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetVersionHistoryQueryKey(params),
    queryFn: () =>
      sqAuditApi.getVersionHistory(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiSetProductionVersionResponse = models.ProductionVersionOutputV1;
type ApisetProductionVersionMutationParams = Parameters<typeof sqAuditApi.setProductionVersion> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAuditApi.setProductionVersion>;

export function useApiSetProductionVersionMutation(
  options?: Omit<UseMutationOptions<ApiSetProductionVersionResponse, AxiosError<SeeqErrorData>,
    ApisetProductionVersionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiSetProductionVersionResponse, AxiosError<SeeqErrorData>,
  ApisetProductionVersionMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApisetProductionVersionMutationParams) =>
      sqAuditApi.setProductionVersion(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateVersionHistoryResponse = models.VersionHistoryOutputV1;
type ApiupdateVersionHistoryMutationParams = Parameters<typeof sqAuditApi.updateVersionHistory> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAuditApi.updateVersionHistory>;

export function useApiUpdateVersionHistoryMutation(
  options?: Omit<UseMutationOptions<ApiUpdateVersionHistoryResponse, AxiosError<SeeqErrorData>,
    ApiupdateVersionHistoryMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUpdateVersionHistoryResponse, AxiosError<SeeqErrorData>,
  ApiupdateVersionHistoryMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiupdateVersionHistoryMutationParams) =>
      sqAuditApi.updateVersionHistory(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
